<template>
  <div class="c-aed-status">
    <div
      class="o-grid o-grid--direction-column o-grid--align-items-center o-grid--justify-content-start"
    >
      <div class="o-grid__group">
        <div class="c-aed-status__item o-grid__item o-grid__item--12">
          <span class="c-aed-status__item-name">
            {{ translationsStatus.status }}
          </span>
          <span class="c-aed-status__item-value"
            ><span
              class="o-status--text"
              :class="status.statusDetailsValue | statusToColor"
              >{{
                translationsStatus.code[status.statusDetails] ||
                  status.statusDetails
              }}</span
            ></span
          >
        </div>
        <div class="c-aed-status__item o-grid__item o-grid__item--12">
          <span class="c-aed-status__item-name">
            {{ translationsStatus.assignee }}
          </span>
          <span class="c-aed-status__item-value"
            ><div v-if="assignee.name">
              {{ assignee.name }}
            </div>
            <span
              tabindex="0"
              class="c-aed-status__item-assign"
              v-if="assignee.id !== userInfo.Id"
              @click="assignToMe()"
              >{{ translationsStatus.assignToMe }}</span
            ></span
          >
        </div>
        <div class="c-aed-status__item o-grid__item o-grid__item--12">
          <span class="c-aed-status__item-name">
            {{ translationsStatus.created }}
          </span>
          <span class="c-aed-status__item-value">{{
            status.created | formatDate("DD. MMM. YYYY")
          }}</span>
        </div>
        <div class="c-aed-status__item o-grid__item o-grid__item--12">
          <span class="c-aed-status__item-name">
            {{ translationsStatus.lastUpdated }}
          </span>
          <span
            class="c-aed-status__item-value c-aed-status__item-value--updated"
          >
            <p>
              {{ status.lastUpdated | formatDate("DD. MMM. YYYY") }}
            </p>
            <p>
              {{ status.lastUpdatedProfile || status.lastUpdatedSystemUser }}
            </p>
          </span>
        </div>
        <div
          v-if="tipOsReport && tipOsReport.created"
          class="c-aed-status__item o-grid__item o-grid__item--12"
        >
          <span class="c-aed-status__item-name">{{
            translationsStatus.report
          }}</span>
          <span class="c-aed-status__item-value">{{
            tipOsReport.created | formatDate("DD. MMM. YYYY")
          }}</span>
        </div>
        <div
          v-if="tipOsReport && tipOsReport.workflowState"
          class="c-aed-status__item o-grid__item o-grid__item--12"
        >
          <span class="c-aed-status__item-name">
            {{ translationsStatus.reportStatus }}
          </span>
          <span class="c-aed-status__item-value">
            {{
              translationsStatus.code[tipOsReport.workflowState] ||
                tipOsReport.workflowState
            }}</span
          >
        </div>
        <div
          v-if="tipOsReport && tipOsReport.id"
          class="c-aed-status__item o-grid__item o-grid__item--12"
        >
          <span class="c-aed-status__item-name"> </span>
          <span class="c-aed-status__item-value">
            <router-link
              :to="{
                name: 'Tips',
                query: {
                  id: tipOsReport.id,
                  isKnown: tipOsReport.isKnown ? 1 : 0
                }
              }"
              class="o-link"
              target="_blank"
              >{{ translationsStatus.seeReport }}</router-link
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "c-aed-status",
  data() {
    return {};
  },
  methods: {
    assignToMe() {
      const payload = {
        api: this.$api,
        method: "PUT",
        id: this.$store.state.aed.all.id,
        section: "assignee",
        data: this.userInfo.Id
      };
      const { dispatch } = this.$store;
      dispatch("aed/setSection", payload);
    }
  },
  computed: {
    ...mapState("translations", {
      translationsStatus: "status"
    }),
    ...mapState("authentication", ["userInfo"]),
    ...mapGetters("aed", ["status", "assignee", "tipOsReport"])
  }
};
</script>
<style lang="scss">
.c-aed-status {
  background-color: $s-cp-neutral-800;
  padding: toRem(30px);

  line-height: toRem(20px);
  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 5px;
  }

  &__item-name {
    width: 35%;
    @include setStyles("14", $s-typography-sizes);
    margin: toRem(2px 0);
    color: $s-cp-neutral-300;
    margin-right: toRem(20px);
  }

  &__item-value {
    width: 65%;
    @include setStyles("15", $s-typography-sizes);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &--updated {
      * {
        white-space: normal;
        &:last-child {
          color: $s-cp-neutral-400;
        }
      }
    }
  }
  &__item-assign {
    color: $s-cp-sup-blue;
    cursor: pointer;
    width: auto;
  }
}
</style>
